import Delivery from './Delivery';

export default Delivery;
